<template>
  <div style="padding: 0px 20px">
    <v-toolbar
      v-if="!workOrderGraph"
      flat
      class="graphics--toolbar"
    >
      <v-toolbar-title style="font-weight: 700; font-size: 36px">
        {{ $t('sitePage.graphics') }}
      </v-toolbar-title>
      <v-spacer />
      <v-btn
        class="siteTree-btn"
        color="secondary"
        @click="addGraphic"
      >
        <v-icon
          color="#ffffff"
          left
        >
          mdi-plus
        </v-icon>
        {{ $t('administration.add') }}
      </v-btn>
    </v-toolbar>
    <Graphic
      v-for="graphic in graphics"
      :key="graphic.id"
      :graphicId="graphic.id"
      :graphic="graphic"
      :workOrderGraph="workOrderGraph"
      @reload="getGraphic"
    />
  </div>
</template>
<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import Graphic from '@/components/graphics/Graphic';
import GraphicForm from '@/components/forms/GraphicForm.vue';

export default {
    name: 'Graphics',
    components: {
        Graphic,
    },
    props: {
        workOrderGraph: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapGetters([
            'lang',
        ]),
        graphics() {
            return this.$store.getters.graphics;
        },
        hasSiteId() {
            return Boolean(this.$route.params.siteId);
        },
    },
    created() {
        if (this.hasSiteId) this.getGraphic();
    },

    methods: {
        async getGraphic() {
            const { siteId } = this.$route.params;
            this.$store.dispatch('getGraphics', siteId);
        },
        addGraphic() {
            this.$root.$emit('showModal', {
                title: this.$t('graphics.addGraphic'),
                component: Vue.component('GraphicForm', GraphicForm),
                showLangs: false,
                onConfirm: requestPayload => { this.saveGraphic(requestPayload); },
            });
        },
        saveGraphic(graphicName) {
            const { siteId } = this.$route.params;
            this.$store.dispatch('addGraphic', { siteId, graphic: { name: graphicName } });
        },
    },
};
</script>
<style scoped>
  ::v-deep .graphics--toolbar .v-toolbar__content {
    padding: 0px !important;
  }
</style>
